import AOS from 'aos';

jQuery(function ($) {
  AOS.init({
    once: true,
    mirror: false,
    duration: 800,
  });
});
